import { mask, formatTrn } from './masks.js'

export default mask(formatTrn)
